export const OPERATION_INCOME = 1;
export const OPERATION_OUTCOME = 2;

export const TARGET_PARTNER = 1;
export const TARGET_CLIENT = 2;

export const FETCH_COUNTRIES_FAIL = 'vzr/FETCH_COUNTRIES_FAIL';
export const FETCH_COUNTRIES_SUCCESS = 'vzr/FETCH_COUNTRIES_SUCCESS';
export const FETCH_CURRENCIES_FAIL = 'vzr/FETCH_CURRENCIES_FAIL';
export const FETCH_CURRENCIES_SUCCESS = 'vzr/FETCH_CURRENCIES_SUCCESS';
export const FETCH_INSURANCE_COMPANIES_FAIL = 'vzr/FETCH_INSURANCE_COMPANIES_FAIL';
export const FETCH_INSURANCE_COMPANIES_SUCCESS = 'vzr/FETCH_INSURANCE_COMPANIES_SUCCESS';
export const FETCH_TRAVEL_RISKS_FAIL = 'vzr/FETCH_TRAVEL_RISKS_FAIL';
export const FETCH_TRAVEL_RISKS_SUCCESS = 'vzr/FETCH_TRAVEL_RISKS_SUCCESS';
export const FETCH_POLICY_STATUSES_FAIL = 'vzr/FETCH_POLICY_STATUSES_FAIL';
export const FETCH_POLICY_STATUSES_SUCCESS = 'vzr/FETCH_POLICY_STATUSES_SUCCESS';

export const FETCH_PAYMENT_TYPES = 'vzr/FETCH_PAYMENT_TYPES';
export const FETCH_PAYMENT_TYPES_FAIL = 'vzr/FETCH_PAYMENT_TYPES_FAIL';
export const FETCH_PAYMENT_TYPES_SUCCESS = 'vzr/FETCH_PAYMENT_TYPES_SUCCESS';
export const CREATE_PAYMENT_TYPE = 'vzr/CREATE_PAYMENT_TYPE';
export const CREATE_PAYMENT_TYPE_FAIL = 'vzr/CREATE_PAYMENT_TYPE_FAIL';
export const CREATE_PAYMENT_TYPE_SUCCESS = 'vzr/CREATE_PAYMENT_TYPE_SUCCESS';
export const UPDATE_PAYMENT_TYPE = 'vzr/UPDATE_PAYMENT_TYPE';
export const UPDATE_PAYMENT_TYPE_FAIL = 'vzr/UPDATE_PAYMENT_TYPE_FAIL';
export const UPDATE_PAYMENT_TYPE_SUCCESS = 'vzr/UPDATE_PAYMENT_TYPE_SUCCESS';
export const DELETE_PAYMENT_TYPE = 'vzr/DELETE_PAYMENT_TYPE';
export const DELETE_PAYMENT_TYPE_FAIL = 'vzr/DELETE_PAYMENT_TYPE_FAIL';
export const DELETE_PAYMENT_TYPE_SUCCESS = 'vzr/DELETE_PAYMENT_TYPE_SUCCESS';

export const FETCH_PAYMENT_CASHES = 'vzr/FETCH_PAYMENT_CASHES';
export const FETCH_PAYMENT_CASHES_FAIL = 'vzr/FETCH_PAYMENT_CASHES_FAIL';
export const FETCH_PAYMENT_CASHES_SUCCESS = 'vzr/FETCH_PAYMENT_CASHES_SUCCESS';
export const CREATE_PAYMENT_CASH = 'vzr/CREATE_PAYMENT_CASH';
export const CREATE_PAYMENT_CASH_FAIL = 'vzr/CREATE_PAYMENT_CASH_FAIL';
export const CREATE_PAYMENT_CASH_SUCCESS = 'vzr/CREATE_PAYMENT_CASH_SUCCESS';
export const UPDATE_PAYMENT_CASH = 'vzr/UPDATE_PAYMENT_CASH';
export const UPDATE_PAYMENT_CASH_FAIL = 'vzr/UPDATE_PAYMENT_CASH_FAIL';
export const UPDATE_PAYMENT_CASH_SUCCESS = 'vzr/UPDATE_PAYMENT_CASH_SUCCESS';
export const DELETE_PAYMENT_CASH = 'vzr/DELETE_PAYMENT_CASH';
export const DELETE_PAYMENT_CASH_FAIL = 'vzr/DELETE_PAYMENT_CASH_FAIL';
export const DELETE_PAYMENT_CASH_SUCCESS = 'vzr/DELETE_PAYMENT_CASH_SUCCESS';
